var _rect, _circle, _g, _g2, _ellipse, _path, _rect2, _path2, _path3, _path4, _rect3, _g3, _rect4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _g4, _g5, _g6, _g7, _path10, _circle2, _path11, _path12, _path13, _g8, _path14, _g9, _path15, _rect5, _path16, _rect6, _path17, _rect7, _path18, _path19, _rect8, _path20, _path21, _path22, _path23, _path24, _rect9, _path25, _path26, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 645,
    height: 586,
    viewBox: "0 0 645 586",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 504,
    height: 366,
    transform: "translate(48 183)",
    fill: "#120227"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "exclusion"
    },
    filter: "url(#filter0_f_3078_8626)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63.4648,
    cy: 63.4648,
    r: 63.4648,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 194.412 359.139)",
    fill: "#E66F44",
    fillOpacity: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_3078_8626)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.2252,
    cy: 30.5991,
    rx: 51.2252,
    ry: 30.5991,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 246.232 376.817)",
    fill: "#E66F44",
    fillOpacity: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_3078_8626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.181 339.418C290.398 327.746 313.814 319.866 335.592 316.695C357.215 313.547 378.502 314.92 392.472 322.985C406.442 331.051 408.819 343.341 403.366 355.825C397.874 368.398 384.226 381.917 364.009 393.589C343.792 405.262 320.377 413.141 298.599 416.312C276.976 419.46 255.689 418.088 241.719 410.022C227.75 401.957 225.372 389.667 230.825 377.183C236.317 364.609 249.965 351.09 270.181 339.418Z",
    stroke: "#4472E6",
    strokeOpacity: 0.5,
    strokeWidth: 10.8797
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 383.803,
    cy: 360.319,
    rx: 35.5101,
    ry: 35.5101,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M475.065 372.746C475.065 368.769 472.224 366.828 470.804 366.355C358.237 360.673 132.393 349.807 129.552 351.795C126.711 353.784 126.238 356.649 126.356 357.832V368.065C126.356 370.085 127.428 371.952 129.172 372.971L308.393 477.658C311.977 479.751 316.416 479.724 319.974 477.588L475.065 384.465V372.746Z",
    fill: "#0C0413",
    stroke: "url(#paint0_linear_3078_8626)",
    strokeWidth: 0.710202
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 293.963,
    y: 325.873,
    width: 28.4081,
    height: 28.4081,
    rx: 14.204,
    fill: "#FBFAFF",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M304.616 332.975H303.906C301.775 332.975 301.065 334.246 301.065 335.816V336.526V346.469C301.065 347.058 301.733 347.392 302.201 347.037L303.416 346.128C303.7 345.915 304.097 345.943 304.353 346.199L305.532 347.385C305.809 347.662 306.264 347.662 306.541 347.385L307.734 346.192C307.982 345.943 308.38 345.915 308.657 346.128L309.871 347.037C310.34 347.385 311.008 347.051 311.008 346.469V334.395C311.008 333.614 311.647 332.975 312.428 332.975H304.616ZM303.884 341.505C303.494 341.505 303.174 341.185 303.174 340.794C303.174 340.404 303.494 340.084 303.884 340.084C304.275 340.084 304.595 340.404 304.595 340.794C304.595 341.185 304.275 341.505 303.884 341.505ZM303.884 338.664C303.494 338.664 303.174 338.344 303.174 337.954C303.174 337.563 303.494 337.243 303.884 337.243C304.275 337.243 304.595 337.563 304.595 337.954C304.595 338.344 304.275 338.664 303.884 338.664ZM308.167 341.327H306.036C305.745 341.327 305.504 341.086 305.504 340.794C305.504 340.503 305.745 340.262 306.036 340.262H308.167C308.458 340.262 308.7 340.503 308.7 340.794C308.7 341.086 308.458 341.327 308.167 341.327ZM308.167 338.486H306.036C305.745 338.486 305.504 338.245 305.504 337.954C305.504 337.662 305.745 337.421 306.036 337.421H308.167C308.458 337.421 308.7 337.662 308.7 337.954C308.7 338.245 308.458 338.486 308.167 338.486Z",
    fill: "#EBE4FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M312.435 332.975V334.04C312.904 334.04 313.351 334.232 313.678 334.552C314.019 334.9 314.204 335.347 314.204 335.816V337.535C314.204 338.06 313.969 338.302 313.437 338.302H312.073V334.403C312.073 334.204 312.236 334.04 312.435 334.04V332.975ZM312.435 332.975C311.647 332.975 311.008 333.614 311.008 334.403V339.367H313.437C314.559 339.367 315.269 338.657 315.269 337.535V335.816C315.269 335.035 314.949 334.324 314.438 333.806C313.92 333.295 313.216 332.982 312.435 332.975C312.442 332.975 312.435 332.975 312.435 332.975Z",
    fill: "#D8D0ED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M130.863 363.823C124.781 360.312 124.744 354.626 130.78 351.088L276.209 265.847C282.332 262.258 292.356 262.252 298.493 265.833L470.4 366.148C476.359 369.625 476.446 375.208 470.596 378.747L328.372 464.774C322.303 468.445 312.191 468.513 305.976 464.925L218.591 414.473L130.863 363.823Z",
    fill: "#26173B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -0.615053,
    width: 178.261,
    height: 204.538,
    rx: 11.7183,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 134.957 354.049)",
    stroke: "#2D213D",
    strokeWidth: 0.710202
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_3078_8626)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 177.55,
    height: 203.828,
    rx: 11.3632,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 135.041 354.356)",
    fill: "#070509"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 151.472,
    height: 46.1631,
    rx: 5.68161,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 158.037 352.174)",
    fill: "#160D20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M195.153 353.147L196.02 353.648L187.17 358.758L186.303 358.257L195.153 353.147ZM197.027 354.229L197.894 354.73L189.044 359.84L188.177 359.339L197.027 354.229ZM191.07 351.757L199.955 356.887L198.719 357.601L187.687 356.446L187.609 356.491L194.124 360.253L192.78 361.03L183.895 355.9L185.14 355.181L196.181 356.341L196.263 356.293L189.739 352.526L191.07 351.757Z",
    fill: "#ECECEC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M214.128 349.987L203.022 343.575L203.733 343.164L214.839 349.576L214.128 349.987ZM208.692 344.279C208.235 344.068 207.726 343.995 207.165 344.058C206.601 344.12 206.064 344.298 205.555 344.592C205.191 344.802 204.934 345.018 204.783 345.238C204.63 345.457 204.579 345.666 204.631 345.867C204.683 346.064 204.835 346.235 205.087 346.38C205.298 346.502 205.529 346.579 205.781 346.61C206.035 346.641 206.296 346.639 206.562 346.605C206.828 346.569 207.09 346.516 207.347 346.448C207.602 346.378 207.837 346.305 208.054 346.23L209.147 345.859C209.5 345.735 209.885 345.622 210.301 345.518C210.718 345.415 211.15 345.346 211.598 345.311C212.047 345.275 212.492 345.296 212.935 345.371C213.38 345.444 213.802 345.596 214.201 345.827C214.705 346.117 215.021 346.45 215.151 346.826C215.284 347.2 215.218 347.594 214.952 348.008C214.689 348.42 214.21 348.827 213.516 349.228C212.851 349.612 212.17 349.883 211.473 350.042C210.776 350.2 210.096 350.247 209.434 350.182C208.768 350.115 208.154 349.936 207.59 349.644L208.935 348.867C209.282 349.037 209.653 349.132 210.05 349.15C210.446 349.165 210.839 349.12 211.23 349.015C211.62 348.906 211.987 348.753 212.332 348.554C212.71 348.335 212.988 348.107 213.164 347.868C213.341 347.626 213.407 347.394 213.364 347.171C213.318 346.948 213.15 346.752 212.861 346.585C212.598 346.433 212.307 346.352 211.989 346.342C211.674 346.331 211.334 346.367 210.969 346.45C210.608 346.532 210.226 346.641 209.824 346.776L208.488 347.217C207.583 347.515 206.734 347.677 205.941 347.7C205.152 347.722 204.448 347.554 203.829 347.197C203.317 346.901 203.009 346.563 202.905 346.182C202.801 345.801 202.88 345.413 203.143 345.018C203.404 344.62 203.832 344.249 204.427 343.905C205.029 343.558 205.665 343.313 206.336 343.169C207.01 343.024 207.665 342.981 208.301 343.041C208.935 343.1 209.496 343.263 209.985 343.532L208.692 344.279Z",
    fill: "#ECECEC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M226.957 334.635L227.438 335.389L221.734 338.682L221.166 337.979L226.957 334.635ZM227.942 336.1L228.423 336.864L223.504 339.704L222.927 338.996L227.942 336.1ZM225.66 332.664L226.245 333.593C225.945 333.606 225.642 333.636 225.339 333.681C225.035 333.726 224.74 333.793 224.454 333.881C224.165 333.968 223.894 334.084 223.643 334.229C223.18 334.496 222.892 334.806 222.779 335.158C222.667 335.511 222.755 335.891 223.044 336.298C223.333 336.702 223.846 337.117 224.584 337.543C225.321 337.969 226.04 338.265 226.74 338.432C227.443 338.597 228.099 338.647 228.71 338.582C229.317 338.515 229.852 338.348 230.315 338.081C230.569 337.934 230.773 337.778 230.926 337.613C231.083 337.446 231.198 337.279 231.273 337.112C231.349 336.942 231.399 336.779 231.425 336.624L233.043 336.952C233.014 337.289 232.868 337.615 232.605 337.931C232.342 338.247 231.988 338.533 231.542 338.79C230.816 339.209 229.989 339.475 229.061 339.587C228.135 339.697 227.174 339.648 226.176 339.439C225.175 339.228 224.204 338.851 223.261 338.307C222.315 337.761 221.66 337.199 221.296 336.621C220.931 336.043 220.844 335.487 221.035 334.953C221.229 334.417 221.689 333.939 222.415 333.52C222.878 333.253 223.385 333.049 223.938 332.907C224.487 332.763 225.061 332.682 225.66 332.664Z",
    fill: "#ECECEC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M250.042 327.969L243.968 331.476L242.814 330.81L248.888 327.303L250.042 327.969ZM244.741 327.013L240.459 329.485L239.305 328.818L243.587 326.346L244.741 327.013ZM239.86 326.624L243.743 328.706C244.133 328.911 244.419 329.131 244.602 329.367C244.781 329.601 244.81 329.853 244.688 330.123L243.235 330.567C243.383 330.471 243.423 330.356 243.357 330.221C243.29 330.086 243.17 329.951 242.997 329.818C242.82 329.682 242.647 329.569 242.476 329.477L238.572 327.368C237.941 327.031 237.546 326.673 237.387 326.294C237.231 325.913 237.259 325.543 237.47 325.184C237.681 324.825 238.026 324.507 238.507 324.23C238.935 323.983 239.39 323.802 239.873 323.686C240.359 323.569 240.842 323.514 241.322 323.521C241.802 323.524 242.249 323.587 242.663 323.709C243.076 323.831 243.425 324.009 243.708 324.242L242.255 324.851C242 324.671 241.72 324.56 241.413 324.52C241.107 324.48 240.801 324.493 240.498 324.558C240.194 324.623 239.925 324.723 239.691 324.859C239.445 325 239.269 325.169 239.162 325.364C239.058 325.558 239.055 325.764 239.153 325.981C239.254 326.196 239.49 326.411 239.86 326.624Z",
    fill: "#ECECEC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M252.742 316.152L259.657 317.689L259.231 318.571L251.301 316.983L252.742 316.152ZM258.967 318.073L256.307 314.093L257.748 313.261L260.498 317.84L258.967 318.073ZM259.396 317.173L264.068 319.871L262.732 320.642L258.06 317.945L259.396 317.173ZM261.474 316.199L262.351 316.705L257.205 319.676L256.329 319.17L261.474 316.199ZM263.192 317.191L264.068 317.697L258.923 320.667L258.047 320.161L263.192 317.191Z",
    fill: "#ECECEC"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M274.762 305.902L275.53 306.696L269.843 309.98L269.075 309.186L274.762 305.902ZM278.745 311.398L271.869 311.014L271.014 310.531L272.554 309.642C272.939 309.42 273.205 309.198 273.352 308.976C273.5 308.754 273.53 308.537 273.444 308.327C273.354 308.115 273.146 307.914 272.819 307.726C272.333 307.445 271.802 307.306 271.227 307.308C270.651 307.309 270.055 307.488 269.439 307.843L267.791 308.795L266.954 307.946L268.285 307.177C269.003 306.763 269.708 306.488 270.402 306.351C271.097 306.214 271.76 306.196 272.394 306.298C273.027 306.4 273.608 306.604 274.138 306.909C274.609 307.181 274.942 307.482 275.135 307.811C275.329 308.14 275.341 308.492 275.17 308.868C274.999 309.244 274.6 309.636 273.973 310.045L273.942 310.073L280.254 310.441L280.328 310.483L278.745 311.398ZM272.632 304.668L273.404 305.469L268.832 308.079L268.086 307.292L272.632 304.668Z",
    fill: "#ECECEC"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M295.829 294.551L296.783 295.102L285.573 301.574L284.619 301.023L295.829 294.551ZM297.777 295.676L298.731 296.227L287.521 302.699L286.567 302.148L297.777 295.676ZM283.023 298.669L291.681 301.614L291.764 301.567L286.697 296.547L288.076 295.751L296.774 298.679L296.857 298.631L291.751 293.63L293.052 292.878L299.534 299.395L298.154 300.192L289.651 297.417L289.582 297.457L294.388 302.366L293.009 303.162L281.721 299.42L283.023 298.669Z",
    fill: "#ECECEC"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_3078_8626)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 142.04,
    height: 5.68161,
    rx: 2.84081,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 210.076 384.184)",
    fill: "#473B53"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_3078_8626)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 142.04,
    height: 5.68161,
    rx: 2.84081,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 223.197 391.759)",
    fill: "#473B53"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_3078_8626)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86.6762,
    height: 5.68161,
    rx: 2.84081,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 236.318 399.335)",
    fill: "#473B53"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_3078_8626)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56.271,
    height: 5.68161,
    rx: 2.84081,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 249.44 406.91)",
    fill: "#473B53"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M310.412 442.119C310.412 442.119 313.498 433.143 313.214 428.852C312.93 424.56 312.043 420.566 309.158 414.488C306.273 408.41 297.134 402.4 291.645 401.86C288.189 401.52 284.836 403.113 284.649 405.632C284.424 408.647 289.514 411.776 295.622 414.56C300.162 416.629 307.162 418.701 311.11 420.91C315.058 423.118 316.293 419.725 316.949 419.551C318.138 419.237 319.593 423.809 322.806 421.753C325.839 419.812 329.139 413.41 321.889 413.68C320.851 413.718 318.197 414.323 318.174 415.679C318.151 417.035 320.817 419.013 324.428 420.788C328.226 422.654 333.127 418.251 334.678 416.459C337.387 413.331 332.294 411.889 333.802 408.908C336.668 403.243 348.695 402.43 351.706 397.471C352.918 395.476 361.621 396.937 360.549 392.944",
    stroke: "#11A811",
    strokeWidth: 1.4204,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.26121,
    cy: 4.26121,
    r: 4.26121,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 387.828 415.787)",
    fill: "#422F5D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M152.186 369.935C96.3066 392.485 63.4797 412.141 71.3225 420.674C83.4714 433.893 188.609 415.418 306.154 379.409C423.699 343.4 509.139 303.492 496.99 290.273C488.611 281.155 435.99 287.116 365.572 303.51",
    stroke: "url(#paint1_radial_3078_8626)",
    strokeWidth: 1.4204
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M247.014 441.84C209.487 469.516 177.905 485.117 164.375 480.607C141.928 473.124 177.667 413.123 244.2 346.589C310.733 280.056 382.867 232.185 405.314 239.668C420.547 244.745 408.984 274.009 379.186 313.087",
    stroke: "url(#paint2_radial_3078_8626)",
    strokeWidth: 1.4204
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.3,
    filter: "url(#filter9_f_3078_8626)"
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M276.564 114.588L140.205 156.49V356.767L146.597 361.028L312.074 456.55L457.665 371.681L509.51 298.175L276.564 114.588Z",
    fill: "url(#paint3_linear_3078_8626)",
    fillOpacity: 0.05
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter10_f_3078_8626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.963 80.1436L80.5469 148.323L140.204 356.767L146.596 361.028L312.073 456.551L457.664 371.681L564.905 281.486L293.963 80.1436Z",
    fill: "url(#paint4_linear_3078_8626)",
    fillOpacity: 0.15
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.807 272.114C265.335 275.288 267.697 278.379 271.895 280.803C281.497 286.346 297.146 286.346 306.748 280.803C310.108 278.862 312.293 276.495 313.301 273.999L287.422 259.057L264.807 272.114ZM293.643 275.027V263.618C293.626 263.024 292.807 262.552 291.796 262.552C290.785 262.552 289.949 263.035 289.949 263.618L289.949 273.961L281.932 273.961C280.922 273.961 280.085 274.444 280.085 275.027C280.085 275.611 280.922 276.094 281.932 276.094L291.796 276.094C292.284 276.094 292.754 275.983 293.103 275.782C293.451 275.581 293.643 275.309 293.643 275.027Z",
    fill: "black",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_3078_8626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.993 247.543C281.935 241.803 298.134 241.803 308.076 247.542C318.018 253.282 318.018 262.636 308.076 268.375C298.134 274.115 281.935 274.115 271.993 268.375C262.052 262.635 262.052 253.283 271.993 247.543ZM292.509 250.271C291.979 250.272 291.532 250.529 291.532 250.835V261.681L290.662 261.681H282.646C282.115 261.681 281.668 261.939 281.668 262.245C281.668 262.551 282.115 262.81 282.646 262.81L292.51 262.809C292.769 262.809 293.017 262.75 293.2 262.645C293.384 262.539 293.486 262.395 293.486 262.245V250.836C293.47 250.512 293.027 250.271 292.509 250.271Z",
    stroke: "#E5A401",
    strokeWidth: 1.4204,
    style: {
      mixBlendMode: "hard-light"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M272.608 247.898C263.006 253.442 263.006 262.476 272.608 268.02C282.21 273.564 297.859 273.564 307.461 268.02C317.063 262.476 317.063 253.442 307.461 247.898C297.859 242.354 282.21 242.354 272.608 247.898ZM294.356 250.836L294.356 262.245C294.356 262.527 294.165 262.798 293.816 263C293.468 263.201 292.997 263.312 292.509 263.312L282.646 263.312C281.635 263.312 280.799 262.829 280.799 262.245C280.799 261.662 281.635 261.179 282.646 261.179L290.662 261.179L290.662 250.836C290.662 250.252 291.498 249.769 292.509 249.769C293.52 249.769 294.339 250.242 294.356 250.836Z",
    fill: "#E5A401",
    fillOpacity: 0.7,
    style: {
      mixBlendMode: "hard-light"
    }
  }), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_f_3078_8626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.608 247.898C263.006 253.442 263.006 262.476 272.608 268.02C282.21 273.564 297.859 273.564 307.461 268.02C317.063 262.476 317.063 253.442 307.461 247.898C297.859 242.354 282.21 242.354 272.608 247.898ZM294.356 250.836L294.356 262.245C294.356 262.527 294.165 262.798 293.816 263C293.468 263.201 292.997 263.312 292.509 263.312L282.646 263.312C281.635 263.312 280.799 262.829 280.799 262.245C280.799 261.662 281.635 261.179 282.646 261.179L290.662 261.179L290.662 250.836C290.662 250.252 291.498 249.769 292.509 249.769C293.52 249.769 294.339 250.242 294.356 250.836Z",
    fill: "white",
    fillOpacity: 0.7
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M272.608 247.898C263.006 253.442 263.006 262.476 272.608 268.02C282.21 273.564 297.859 273.564 307.461 268.02C317.063 262.476 317.063 253.442 307.461 247.898C297.859 242.354 282.21 242.354 272.608 247.898ZM294.356 250.836L294.356 262.245C294.356 262.527 294.165 262.798 293.816 263C293.468 263.201 292.997 263.312 292.509 263.312L282.646 263.312C281.635 263.312 280.799 262.829 280.799 262.245C280.799 261.662 281.635 261.179 282.646 261.179L290.662 261.179L290.662 250.836C290.662 250.252 291.498 249.769 292.509 249.769C293.52 249.769 294.339 250.242 294.356 250.836Z",
    fill: "#E5A401"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 80.9025,
    y: 382.69,
    width: 28.4081,
    height: 28.4081,
    rx: 14.204,
    fill: "#FBFAFF",
    fillOpacity: 0.1
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0823 389.792H92.1308C89.5457 389.792 88.0046 391.333 88.0046 393.919V399.87C88.0046 402.455 89.5457 403.996 92.1308 403.996H98.0823C100.667 403.996 102.209 402.455 102.209 399.87V393.919C102.209 391.333 100.667 389.792 98.0823 389.792ZM92.0882 398.031C92.0882 398.322 91.8467 398.563 91.5556 398.563C91.2644 398.563 91.0229 398.322 91.0229 398.031V395.758C91.0229 395.467 91.2644 395.225 91.5556 395.225C91.8467 395.225 92.0882 395.467 92.0882 395.758V398.031ZM95.6392 399.266C95.6392 399.558 95.3978 399.799 95.1066 399.799C94.8154 399.799 94.5739 399.558 94.5739 399.266V394.522C94.5739 394.231 94.8154 393.99 95.1066 393.99C95.3978 393.99 95.6392 394.231 95.6392 394.522V399.266ZM99.1902 398.031C99.1902 398.322 98.9488 398.563 98.6576 398.563C98.3664 398.563 98.1249 398.322 98.1249 398.031V395.758C98.1249 395.467 98.3664 395.225 98.6576 395.225C98.9488 395.225 99.1902 395.467 99.1902 395.758V398.031Z",
    fill: "#BFA6FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 168.888,
    y: 396.894,
    width: 28.4081,
    height: 28.4081,
    rx: 14.204,
    fill: "#FBFAFF",
    fillOpacity: 0.1
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M189.981 409.806C189.411 406.977 187.214 404.78 184.384 404.209C183.864 404.105 183.323 404.238 182.906 404.578C182.492 404.918 182.254 405.42 182.254 405.954V409.806C182.254 410.981 183.21 411.937 184.384 411.937H188.236C188.772 411.937 189.273 411.699 189.613 411.284C189.952 410.87 190.087 410.331 189.981 409.806ZM188.515 410.384C188.474 410.433 188.384 410.517 188.236 410.517H184.384C183.992 410.517 183.674 410.198 183.674 409.806V405.954C183.674 405.807 183.757 405.717 183.807 405.676C183.847 405.643 183.925 405.594 184.031 405.594C184.054 405.594 184.078 405.596 184.105 405.602C186.371 406.059 188.133 407.819 188.589 410.086C188.618 410.23 188.555 410.335 188.515 410.384ZM188.41 413.362C188.543 413.562 188.57 413.815 188.479 414.039C187.489 416.484 185.166 418.022 182.566 418.022C182.341 418.022 182.113 418.01 181.884 417.987C178.947 417.685 176.505 415.243 176.203 412.306C175.908 409.437 177.495 406.787 180.152 405.711C180.377 405.621 180.63 405.646 180.828 405.78C181.023 405.912 181.139 406.131 181.139 406.366V411.276C181.139 412.255 181.936 413.051 182.915 413.051H187.824C188.059 413.051 188.278 413.168 188.41 413.362Z",
    fill: "#BFA6FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 166.004,
    y: 466.848,
    width: 28.4081,
    height: 28.4081,
    rx: 14.204,
    fill: "#FBFAFF",
    fillOpacity: 0.1
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M185.3 477.246C184.995 475.705 183.851 475.03 182.261 475.03H176.025C174.15 475.03 172.9 475.967 172.9 478.155V481.812C172.9 483.389 173.546 484.312 174.612 484.71C174.768 484.767 174.938 484.816 175.116 484.845C175.4 484.909 175.705 484.937 176.025 484.937H182.268C184.143 484.937 185.393 484 185.393 481.812V478.155C185.393 477.821 185.364 477.523 185.3 477.246ZM175.613 481.052C175.613 481.344 175.372 481.585 175.08 481.585C174.789 481.585 174.548 481.344 174.548 481.052V478.922C174.548 478.631 174.789 478.389 175.08 478.389C175.372 478.389 175.613 478.631 175.613 478.922V481.052ZM179.143 481.862C178.106 481.862 177.268 481.024 177.268 479.987C177.268 478.95 178.106 478.112 179.143 478.112C180.18 478.112 181.018 478.95 181.018 479.987C181.018 481.024 180.18 481.862 179.143 481.862ZM183.731 481.052C183.731 481.344 183.489 481.585 183.198 481.585C182.907 481.585 182.665 481.344 182.665 481.052V478.922C182.665 478.631 182.907 478.389 183.198 478.389C183.489 478.389 183.731 478.631 183.731 478.922V481.052Z",
    fill: "#BFA6FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M187.523 480.285V483.943C187.523 486.13 186.273 487.075 184.391 487.075H178.156C177.623 487.075 177.147 486.997 176.735 486.841C176.401 486.72 176.11 486.542 175.876 486.315C175.748 486.194 175.847 486.002 176.025 486.002H182.261C184.888 486.002 186.451 484.44 186.451 481.819V478.155C186.451 477.984 186.642 477.878 186.763 478.006C187.246 478.517 187.523 479.263 187.523 480.285Z",
    fill: "#BFA6FF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 385.853,
    y: 262.456,
    width: 28.4081,
    height: 28.4081,
    rx: 14.204,
    fill: "#FBFAFF",
    fillOpacity: 0.1
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M405.809 273.066C405.809 273.45 405.603 273.798 405.277 273.975L404.041 274.643L402.99 275.204L400.81 276.383C400.575 276.511 400.319 276.574 400.057 276.574C399.794 276.574 399.538 276.511 399.304 276.383L394.837 273.975C394.51 273.798 394.304 273.45 394.304 273.066C394.304 272.683 394.51 272.335 394.837 272.157L396.236 271.404L397.351 270.801L399.304 269.749C399.773 269.494 400.341 269.494 400.81 269.749L405.277 272.157C405.603 272.335 405.809 272.683 405.809 273.066Z",
    fill: "#BFA6FF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M398.565 277.221L394.411 275.147C394.091 274.984 393.722 275.005 393.416 275.19C393.111 275.374 392.933 275.701 392.933 276.056V279.983C392.933 280.665 393.31 281.276 393.921 281.581L398.075 283.655C398.217 283.726 398.374 283.762 398.53 283.762C398.714 283.762 398.899 283.712 399.062 283.605C399.368 283.421 399.545 283.094 399.545 282.739V278.812C399.552 278.137 399.176 277.526 398.565 277.221Z",
    fill: "#BFA6FF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M407.18 276.056V279.983C407.18 280.658 406.804 281.269 406.193 281.574L402.038 283.655C401.896 283.726 401.74 283.762 401.584 283.762C401.399 283.762 401.214 283.712 401.044 283.605C400.746 283.421 400.561 283.094 400.561 282.739V278.819C400.561 278.137 400.937 277.526 401.548 277.221L403.075 276.461L404.14 275.928L405.703 275.147C406.022 274.984 406.392 274.998 406.697 275.19C406.995 275.374 407.18 275.701 407.18 276.056Z",
    fill: "#BFA6FF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M404.041 274.643L402.99 275.204L396.236 271.404L397.351 270.801L403.871 274.479C403.942 274.522 403.998 274.579 404.041 274.643Z",
    fill: "#BFA6FF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M404.14 275.928V277.54C404.14 277.832 403.899 278.073 403.608 278.073C403.317 278.073 403.075 277.832 403.075 277.54V276.461L404.14 275.928Z",
    fill: "#BFA6FF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 465.324,
    y: 272.402,
    width: 28.4081,
    height: 28.4081,
    rx: 14.204,
    fill: "#FBFAFF",
    fillOpacity: 0.1
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M482.504 279.504H476.553C473.968 279.504 472.426 281.046 472.426 283.631V289.575C472.426 292.167 473.968 293.708 476.553 293.708H482.497C485.082 293.708 486.623 292.167 486.623 289.582V283.631C486.63 281.046 485.089 279.504 482.504 279.504ZM483.683 288.098C483.655 288.162 483.619 288.219 483.569 288.268L481.41 290.427C481.304 290.534 481.169 290.584 481.034 290.584C480.899 290.584 480.764 290.534 480.658 290.427C480.452 290.221 480.452 289.88 480.658 289.675L481.908 288.425H475.871C475.58 288.425 475.338 288.183 475.338 287.892C475.338 287.601 475.58 287.359 475.871 287.359H483.193C483.264 287.359 483.328 287.373 483.399 287.402C483.527 287.459 483.633 287.558 483.69 287.693C483.733 287.821 483.733 287.97 483.683 288.098ZM483.186 285.847H475.871C475.8 285.847 475.736 285.832 475.665 285.804C475.537 285.747 475.431 285.648 475.374 285.513C475.317 285.385 475.317 285.236 475.374 285.108C475.402 285.044 475.438 284.987 475.487 284.937L477.646 282.778C477.852 282.572 478.193 282.572 478.399 282.778C478.605 282.984 478.605 283.325 478.399 283.531L477.156 284.781H483.193C483.484 284.781 483.726 285.023 483.726 285.314C483.726 285.605 483.484 285.847 483.186 285.847Z",
    fill: "#BFA6FF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M314.561 467.203L314.561 479.277",
    stroke: "url(#paint5_linear_3078_8626)",
    strokeWidth: 0.710202
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3078_8626",
    x: 45.2801,
    y: 132.934,
    width: 518.113,
    height: 452.409,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 90.6641,
    result: "effect1_foregroundBlur_3078_8626"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3078_8626",
    x: 197.414,
    y: 268.668,
    width: 239.361,
    height: 195.674,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 33.999,
    result: "effect1_foregroundBlur_3078_8626"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_3078_8626",
    x: 153.465,
    y: 243.292,
    width: 327.261,
    height: 246.423,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 33.999,
    result: "effect1_foregroundBlur_3078_8626"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_3078_8626",
    x: 137.965,
    y: 266.069,
    width: 321.595,
    height: 186.874,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2.84081,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_3078_8626"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.84081,
    dy: -2.84081
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.52242
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.186384 0 0 0 0 0.119075 0 0 0 0 0.276129 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3078_8626"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_3078_8626",
    x: 208.677,
    y: 313.995,
    width: 130.73,
    height: 77.8785,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.84081
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.4204
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3078_8626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3078_8626",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_3078_8626",
    x: 221.798,
    y: 321.571,
    width: 130.73,
    height: 77.8785,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.84081
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.4204
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3078_8626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3078_8626",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_3078_8626",
    x: 234.919,
    y: 356.829,
    width: 82.7835,
    height: 50.1964,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.84081
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.4204
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3078_8626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3078_8626",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_3078_8626",
    x: 248.04,
    y: 379.607,
    width: 56.4518,
    height: 34.9938,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.84081
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.4204
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3078_8626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3078_8626",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_3078_8626",
    x: 83.3889,
    y: 57.7717,
    width: 482.937,
    height: 455.594,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0,
    result: "effect1_foregroundBlur_3078_8626"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_3078_8626",
    x: 0.546875,
    y: 0.143555,
    width: 644.358,
    height: 536.407,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 28.4081,
    result: "effect1_foregroundBlur_3078_8626"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_3078_8626",
    x: 252.787,
    y: 231.856,
    width: 74.4946,
    height: 52.2061,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.43984,
    result: "effect1_foregroundBlur_3078_8626"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_3078_8626",
    x: 263.986,
    y: 242.32,
    width: 52.0968,
    height: 31.2788,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.710202,
    result: "effect1_foregroundBlur_3078_8626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3078_8626",
    x1: 300.703,
    y1: 351.556,
    x2: 300.703,
    y2: 481.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231A2B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#231A2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231A2B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3078_8626",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(429.994 -127.107 40.3313 45.4794 68.3056 418.804)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#442C51",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.245192,
    stopColor: "#442C51",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504808,
    stopColor: "#9964B7",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.721154,
    stopColor: "#442C51",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889423,
    stopColor: "#9964B7",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#442C51",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3078_8626",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(247.624 -239.475 75.8611 26.1502 155.209 478.316)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#442C51",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235577,
    stopColor: "#442C51",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504808,
    stopColor: "#9964B7",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.721154,
    stopColor: "#442C51",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.836538,
    stopColor: "#442C51",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9964B7",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3078_8626",
    x1: 324.858,
    y1: 114.588,
    x2: 324.858,
    y2: 456.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3078_8626",
    x1: 322.726,
    y1: 80.1436,
    x2: 322.726,
    y2: 456.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822976,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3078_8626",
    x1: 315.061,
    y1: 467.203,
    x2: 315.061,
    y2: 479.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231A2B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#231A2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231A2B",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.74266c11249038992950b2b97c697e6b.svg";
export { ForwardRef as ReactComponent };